import SelectedTranscriptDisplay from './SelectedTranscriptDisplay'
import VideoClipPlayer from './VideoClipPlayer'
import TabList from './TabList'
import TabPanel from './TabPanel'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { scrollOnTimeUpdateWithFeatures } from '../utils/scrollOnTimeUpdate'

export default class VideoClipMain extends Component {
  static propTypes = {
    clip: PropTypes.object.isRequired,
    playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    searchHighlights: PropTypes.array
  }

  constructor(props) {
    super(props)

    this.toggleTranscript = this.toggleTranscript.bind(this)

    this.state = {
      showTranscript: true
    }
  }

  toggleTranscript() {
    const { showTranscript } = this.state
    this.setState({ showTranscript: !showTranscript })
  }

  getTranscript() {
    const { clip, searchHighlights } = this.props
    const { showTranscript } = this.state
    let transcript

    if (clip.video.timestampRequestStatus !== 'processing') {
      transcript = clip.transcript
    }

    if (!transcript) {
      return (
        <span className="grey-reg-i">{I18n.t('No transcript provided')}</span>
      )
    }

    if (showTranscript) {
      return [
        <a key="transcriptLink" onClick={this.toggleTranscript}>
          {I18n.t('Hide Transcript')}
        </a>,
        <SelectedTranscriptDisplay
          videoTranscript={clip.videoTranscript}
          startTime={clip.startTime}
          endTime={clip.endTime}
          key={clip.id}
          searchHighlights={searchHighlights}
        />
      ]
    } else {
      return <a onClick={this.toggleTranscript}>{I18n.t('Show Transcript')}</a>
    }
  }

  render() {
    const { clip, playerId } = this.props
    const { video } = clip

    return (
      <div>
        <VideoClipPlayer
          id={playerId}
          src={video.src}
          captionSource={video.captionUrl}
          languages={clip.languages}
          startTime={clip.startTime}
          endTime={clip.endTime}
          width="auto"
          height={480}
          restrictPlaybackToClip={clip.restrictPlaybackToClip}
          listeners={{
            timeupdate: e =>
              clip.videoTranscript &&
              scrollOnTimeUpdateWithFeatures(
                e,
                clip.videoTranscript.jsonTimestamps
              )
          }}
        />
        {clip.restrictPlaybackToClip || (
          <TabList>
            <TabPanel title="Transcript">{this.getTranscript()}</TabPanel>
          </TabList>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/VideoClipMain.js